import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CarListingFaq from "./component";

const mapStateToProps = () => ({
    carListing: {
        isSSR
    },
    cities: { selectedCity: { code: selectedCityCode, name: selectedCityName } = {} },
    filters: {
        allFilters,
        urlOptions,
        selectedFilters,
        appliedFilters,
        appliedSuggestions
    },
    clpData: {
        faqData
    }

}) => ({
    selectedCityCode,
    selectedCityName,
    selectedFilters,
    allFilters,
    urlOptions,
    appliedFilters,
    appliedSuggestions,
    isSSR,
    faqData
});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarListingFaq);
